/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

import axios from 'axios';
import auth from '../../../common/auth';
import common from "../../../../../ui-src-brainiac/src/store/modules/common";

export default {
  // eslint-disable-next-line
  broadcastLogin({ commit }) {
    return axios({
      url: 'api/broadcastLogin',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  // eslint-disable-next-line
  sendFriendInvitation({ commit }, payload) {
    return axios({
      url: 'api/sendFriendInvitation',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: payload,
    });
  },
  getUserAchievements({ commit }) {
    return axios({
      url: `api/fetchUserAchievements`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const { responseEnum, data } = response.data;
      if (responseEnum === 'OPERATION_SUCCESS') {
        commit('setUserAchievements', data.achievementCategoryDTOs);
        commit('common/setTotalAchievements', { value: data.totalNumberOfAchievements }, { root: true });
      }
    }).catch((error) => {
      console.log(`Invoking getUserAchievements failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  isEligibleForSharePoints({ commit }, payload) {
    return axios({
      method: 'get',
      url: `api/isEligibleForShareReward?action=${payload.action}&uniqueId=${payload.id}`,
      headers: {
        Authorization: auth.getJwt(),
      },
    }).catch((error) => {
      console.log(`Invoking api/isEligibleForShareReward failed with the following error: ${error}`);
    });
  },
  storeJackpotRankData({ commit }) {
    return axios({
      method: 'get',
      url: 'api/getJackpotRanking',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const percentages = response.data.data
        .filter(item => item.rankValueType === 'PERCENTAGE');
      const absolutesSortedArray = response.data.data
        .filter(item => item.rankValueType === 'ABSOLUTE')
        .sort((item1, item2) => item1.priority - item2.priority)
        .map((item) => {
          const itemFound = percentages.find(perc => perc.rankKeyType === item.rankKeyType);
          Object.assign(item, { percentage: itemFound ? itemFound.value : '' });
          return item;
        });
      commit('setJackpotRanks', absolutesSortedArray);
    }).catch((error) => {
      console.log(`Invoking api/storeJackpotRanking failed with the following error: ${error}`);
    });
  },
  storeJackpotPrizes({ commit }, payload) {
    return axios({
      method: 'post',
      url: 'api/getJackpotPrizes',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        language: payload.lang,
      },
    }).then((response) => {
      commit('setJackpotPrizes', response.data.data.filter(item => item.itemsLeft));
    }).catch((error) => {
      console.log(`Invoking api/storeJackpotPrizes failed with the following error: ${error}`);
    });
  },
  getPrizeHistory({ commit }) {
    return axios({
      method: 'get',
      url: 'api/getUserDetailsWithHistory',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      const wonPrizes = response.data.data.prizeWonDTOList;
      commit({ type: 'common/updateWonPrizes', prizes: wonPrizes }, { root: true });
    }).catch((error) => {
      console.log(`Invoking api/getUserDetailsWithHistory failed with the following error: ${error}`);
    });
  },
  logoutUserFromAuthorizedPages({ commit }) {
    commit('clearAllData');
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('username');
    sessionStorage.removeItem('jwtToken');
    sessionStorage.removeItem('username');
    commit('setjwtFromStorage', null);
    commit('setUserAuthorized', false);
    window.location.reload();
    this.$router.push('/login');
  },
  sendReOptinPin({ dispatch, commit }, payload) {
    // eslint-disable-next-line
    console.log('Verification Reoptin Pin Process' + payload.pinObject.pin);
    return axios({
      url: 'api/verifyReoptinPin',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        pin: payload.pinObject.pin,
        ti: payload.pinObject.ti,
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit('setSuccessForReoptinWith2StepVerificationVerified', true);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', false);
        commit('setSuccessForReoptinWith2StepVerificationServerError', false);
      } else if (response.data.responseEnum === 'WRONG_PIN' || response.data.responseEnum === 'PIN_EXPIRED') {
        commit('setSuccessForReoptinWith2StepVerificationVerified', false);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', true);
        commit('setSuccessForReoptinWith2StepVerificationServerError', false);
      } else {
        commit('setSuccessForReoptinWith2StepVerificationVerified', false);
        commit('setSuccessForReoptinWith2StepVerificationWrongPin', false);
        commit('setSuccessForReoptinWith2StepVerificationServerError', true);
      }
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking sendReOptinPin failed with the following error: ${error}`);
    });
  },
  clearNotifications({ dispatch, commit }) {
    return axios({
      url: 'api/clearNotifications',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        const tempNotifications = [];
        commit({ type: 'storeNotifications', notifications: tempNotifications });
      }
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking clearNotifications failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  changeUsername({ commit }, payload) {
    return axios({
      url: `api/changeUsername?username=${payload.username}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit('common/updateUsername', payload.username, { root: true });
        if (localStorage.getItem('username')) {
          localStorage.setItem('username', payload.username);
        }
      }
      return response;
    });
  },
  changeNotificationReadStatus() {
    console.log('changeNotificationReadStatus process: ');
    return axios({
      url: 'api/changeNotificationReadStatus',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  getLastSharedRankDate() {
    return axios({
      url: 'api/getLastSharedRankDate',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  getLastSharedLevel() {
    return axios({
      url: 'api/getLastSharedLevel',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  // eslint-disable-next-line
  giveContent({ dispatch, commit }, payload) {
    console.log('giveContent process: ');
    return axios({
      url: 'api/giveContent',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        action: payload.action,
        userCurrentPoints: payload.points,
        uniqueId: payload.uniqueId,
      },
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking giveContent failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  sendNotificationReward({ commit }, payload) {
    return axios({
      url: `api/sendReward?id=${payload.reward}&notificationId=${payload.notif}`,
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    });
  },
  getUserNotifications({ dispatch, commit, state }) {
    return axios({
      url: 'api/getStoredNotificationsV2',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      // success callback
      let notifications = response.data.data;
      const achievements = state.achievements.flatMap(a => a.achievementDTOs).flatMap(ad => ad.achievementLevelDTOs.map(l => ({ ...l, category: ad.achievementName }))).map(al => `${al.category}_${al.achievementLevelName}`);
      const resultSet = new Set(achievements);
      notifications = notifications.filter(obj => resultSet.has(obj.text) || obj.notificationCategoryDTO.name !== 'Achievement');
      commit({ type: 'storeNotifications', notifications });
      commit({ type: 'storeAchievementNotificationData', notifications: notifications.filter(not => not.notificationCategoryDTO.name === 'Achievement') });
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking getUserNotifications failed with the following error: ${error}`);
    });
  },
  requestPin({ dispatch, commit }, payload) {
    console.log('Get Pin Process');
    return axios({
      url: 'api/getPin',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        bundleId: payload.value.bundleId,
      },
    }).then((response) => {
      commit({ type: 'setRequestPinResponse', value: response.data.responseEnum });
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking requestPin failed with the following error: ${error}`);
    });
  },
  chargePinCall({ dispatch, commit }, payload) {
    console.log("Invoking chargePinCall");
    return axios({
      url: 'api/charge',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        bundleId: payload.value.bundleId,
        pin: payload.value.pin,
      },
    }).then((response) => {
      commit({ type: 'setChargePinResponse', value: response.data.responseEnum });
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking chargePinCall failed with the following error: ${error}`);
    });
  },
  storedBundlesCall({ dispatch, commit }) {
    return axios({
      url: 'api/getStoreItems',
      method: 'GET',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      // success callback
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        commit({ type: 'setBundles', value: response.data.data });
      }
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking storedBundles failed with the following error: ${error}`);
    });
  },
  setMatchInfo({ dispatch, commit }, payload) {
    commit({ type: 'setGameDetails', details: '' });
    commit({ type: 'setOppDetails', details: '' });
    return axios({
      url: 'api/getMatchHistory',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        duelId: payload.duelId,
      },
    }).then((response) => {
      const gameDetails = response.data.data;
      commit({ type: 'setGameDetails', details: gameDetails });
      const oppDetails = payload;
      commit({ type: 'setOppDetails', details: oppDetails });
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking setMatchInfo failed with the following error: ${error}`);
    });
  },
  storeAvailablePrizeTypes({ state, commit }, userLanguage) {
    return axios({
      url: `api/getPrizeData?lang=${userLanguage}`,
      method: 'GET',
    }).then((response) => {
      // success callback
      // eslint-disable-next-line
      const prizes = response.data.data;
      const types = [];
      /* eslint-disable */
      for (var i = 0; i < prizes.length; i++) {
        types.push(prizes[i].type);
      }
      const carouselPrizes = response.data.data;
      commit({ type: 'setCarouselPrizes', value: carouselPrizes });
      for (var i = 0; i < prizes.length; i++) {
        if (prizes[i].type === state.prizes.WEEKLY) {
          const weeklyPrize = prizes[i];
          commit({ type: 'setWeeklyPrize', value: weeklyPrize });
        } else if (prizes[i].type === state.prizes.DAILY) {
          const dailyPrize = prizes[i];
          commit({ type: 'setDailyPrize', value: dailyPrize });
        } else if (prizes[i].type === state.prizes.MONTHLY) {
          const monthlyPrize = prizes[i];
          commit({ type: 'setMonthlyPrize', value: monthlyPrize });
        } else if (prizes[i].type === state.prizes.GRAND) {
          const grandPrize = prizes[i];
          commit({ type: 'setGrandPrize', value: grandPrize});
        }
      }
      console.log(types);
      /* eslint-enable */
      commit('setAvailablePrizeTypes', types);
    }).catch((error) => {
      console.log(`Invoking storeAvailablePrizetypes failed with the following error: ${error}`);
    });
  },
  storePrizesAndWinners({ dispatch, commit }, payload) {
    return axios({
      url: 'api/getPrizeLeaderboardDetails',
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
      data: {
        language: payload.language,
        prizeType: payload.prizeType,
        gameType: payload.gameType,
      },
    }).then((response) => {
      const responseData = response.data.data;
      if (responseData !== undefined) {
        const prizes = [];
        const winners = [];
        const ranks = [];
        Object.keys(responseData).forEach((key) => {
          if (responseData && Object.prototype.hasOwnProperty.call(responseData, key)) {
            prizes.push({
              activeFrom: (responseData[key]) ? responseData[key].activeFrom : '',
              activeTo: (responseData[key]) ? responseData[key].activeTo : '',
              banner: (responseData[key]) ? responseData[key].banner : '',
              description: (responseData[key]) ? responseData[key].description : '',
              eligibilityCriteria: (responseData[key]) ? responseData[key].eligibilityCriteria : '',
              headline: (responseData[key]) ? responseData[key].headline : '',
              imgUrl: (responseData[key]) ? responseData[key].imgUrl : '',
              type: (responseData[key]) ? responseData[key].type : '',
              lastRefreshed: (responseData[key]) ? responseData[key].lastRefreshed : '',
            });
            winners.push((responseData[key]) ? responseData[key].userRankPointsDTOList : []);
            ranks.push((responseData[key]) ? responseData[key].rankDTO : []);
          }
        });
        if (payload.prizeType === 'DAILY') {
          commit('setDailyPrizeForLeaderboard', prizes);
          commit('setDailyWinnersForLeaderboard', winners);
          commit('setDailyRankForLeaderboard', ranks);
        } else if (payload.prizeType === 'WEEKLY') {
          commit('setWeeklyPrizeForLeaderboard', prizes);
          commit('setWeeklyWinnersForLeaderboard', winners);
          commit('setWeeklyRankForLeaderboard', ranks);
        } else if (payload.prizeType === 'MONTHLY') {
          commit('setMonthlyPrizeForLeaderboard', prizes);
          commit('setMonthlyWinnersForLeaderboard', winners);
          commit('setMonthlyRankForLeaderboard', ranks);
        } else if (payload.prizeType === 'GRAND') {
          commit('setGrandPrizeForLeaderboard', prizes);
          commit('setGrandWinnersForLeaderboard', winners);
          commit('setGrandRankForLeaderboard', ranks);
        } else if (payload.gameType) { // always core returns on 2nd index
          commit('setGameTypeWinnersForLeaderboard', winners[2]);
          commit('setGameTypeRankForLeaderboard', ranks[2]);
        }
      }
    }).catch((error) => {
      dispatch('logoutUserFromAuthorizedPages');
      console.log(`Invoking storePrizeAndWinners failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  resetPassword({ commit, state }, payload) {
    console.log('resetPassword process: ');
    return axios({
      url: 'api/resetUserPassword',
      method: 'POST',
      data: {
        msisdn: payload.msisdn,
        passwordOld: state.hashedPass,
        password: payload.password,
      },
    }).then((response) => {
      console.log(response);
      commit('setHashedPassForForgotPass', null);
    }).catch((error) => {
      console.log(`Invoking resetPassword failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  storePerformance({ commit, state }, msisdn){
    return axios({
      url: `api/getPerformance?msisdn=${msisdn}`,
      method: 'GET',
    }).then((response) => {
      // success callback
      commit('setPerformanceInfo', response.data.data);
    }).catch((error) => {
      console.log(`Invoking storePerformance failed with the following error: ${error}`);
    });
  },
  storeVisitorWinners({ commit, state }, userLanguage) {
    return axios({
      url: `api/getWinnersData?lang=${userLanguage}`,
      method: 'GET',
    }).then((response) => {
      commit('setAllWinners', response.data.data);
      const month = [];
      const grand = [];
      const week = [];
      for (let i = 0; i < state.allWinners.length; i += 1) {
        if (state.allWinners[i].prizeDTO.type === "MONTHLY") {
          month.push(state.allWinners[i]);
        } else if (state.allWinners[i].prizeDTO.type === "GRAND") {
          grand.push(state.allWinners[i]);
        } else if (state.allWinners[i].prizeDTO.type === "WEEKLY") {
          week.push(state.allWinners[i]);
        }
      }
      commit('setMoWinners', month);
      commit('setGrWinners', grand);
      commit('setInWinners', week);
      if (state.monthlyWin.length > state.numberOfTotalPrizes) commit('setMoreWinnersMButton', true);
      if (state.instantWin.length > state.numberOfTotalPrizes) commit('setMoreWinnersIButton', true);
      if (state.grandWin.length > state.numberOfTotalPrizes) commit('setMoreWinnersButton', true);
      // success callback
    }).catch((error) => {
      console.log(`Invoking storeVisitorWinners failed with the following error: ${error}`);
    });
  },
  // eslint-disable-next-line
  checkCoreResponses({ dispatch, commit }) {
    // eslint-disable-next-line
    if (auth.getJwt()) {
      console.log('checkCoreResponses in common');
      return axios({
        url: 'api/getUserLoginDetails',
        method: 'POST',
        headers: {
          Authorization: auth.getJwt(),
        },
        data: {
          language: localStorage.getItem('locale'),
        },
      }).then((response) => {
        console.log('response.data.responseEnum', response.data.responseEnum);
        if (response.data.responseEnum !== 'OPERATION_SUCCESS') {
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('username');
          sessionStorage.removeItem('jwtToken');
          sessionStorage.removeItem('username');
          commit({ type: 'setjwtFromStorage', jwt: null });
          commit('setUserAuthorized', false);
          // eslint-disable-next-line
          console.log('Core is down');
          return 'CORE_IS_DOWN';
        } return null;
      }).catch((error) => {
        dispatch('logoutUserFromAuthorizedPages');
        console.log(`Invoking checkCoreResponses failed with the following error: ${error}`);
      });
    }
  },
  // eslint-disable-next-line
  getUserLoginDetails({ dispatch, commit, state }) {
    console.log('getUserLoginDetails call');
    if (auth.getJwt()) {
      console.log('getUserLoginDetails call with correct jwt');
      commit('setjwtFromStorage', auth.getJwt());
      return axios({
        url: 'api/getUserLoginDetails',
        method: 'POST',
        headers: {
          Authorization: auth.getJwt(),
        },
        data: {
          language: localStorage.getItem('locale'),
        },
        // eslint-disable-next-line
      }).then((response) => {
        console.log('response.data.responseEnum', response.data.responseEnum);
        if (response.data.responseEnum === 'OPERATION_SUCCESS') {
          // userDetails
          const userDetails = response.data.data.userDTO;
          console.log('inside userDetails:', userDetails);
          commit('common/storeUserDetails', userDetails, { root: true });
          console.log('getUserDetails process from DB');
          console.log('Lang from Response: ', userDetails.language);
          localStorage.setItem('locale', userDetails.language);
          return axios({
            url: 'api/userDetails',
            method: 'GET',
            headers: {
              Authorization: auth.getJwt(),
            },
            // eslint-disable-next-line
          }).then((responseUserDetails) => {
            if (responseUserDetails.data.responseEnum === 'OPERATION_SUCCESS') {
              const userDetails = responseUserDetails.data.data;
              // eslint-disable-next-line
              console.log('-------------userDetails From userDetails---------------------------: ' + userDetails.displayAvatar);
              commit('common/storeUserDetailsFromDuel', userDetails, { root: true });
              console.log('TRUE in common');
              return axios({
                url: 'publicapi/getMultiOperatorConfigProperties',
                method: 'GET',
                params: {
                  operatorKey: userDetails.operator || '',
                },
              }).then((response) => {
                commit('common/setReoptinOptoutConfig', { value: response.data.data.reoptinAndOptoutConfig }, { root: true });
                commit('common/updateOptOutFromHome', { value: response.data.data.showOptOutPhase }, { root: true });
                commit('common/updateSubAndUnsubViaSMS', { value: response.data.data.subAndUnsubViaSMS }, { root: true });
                commit('common/updateMultiOperatorOrdinal', { value: response.data.data.multiOperatorOrdinal }, { root: true });
                commit('common/setSmsAutomaticResponse', { value: response.data.data.smsAutomaticResponse }, { root: true });
                commit('common/setHideStore', { value: response.data.data.hideStore }, { root: true });
                commit('common/setDisplayPrice', { value: response.data.data.displayPrice }, { root: true });
                commit('common/updatePinForBundles', { value: response.data.data.pinForBundles }, { root: true });
                commit('common/storePurchaseViaSMS', { value: response.data.data.purchaseViaSMS }, { root: true });
              }).catch((error) => {
                console.log(`Invoking publicapi/getMultiOperatorConfigProperties failed with the following error: ${error}`);
              });
              // sessionStorage.setItem('visitorCurrentTabPath', '/home');
            }
          }).catch((error) => {
            console.log(`Invoking userDetails failed with the following error: ${error}`);
          });
          // eslint-disable-next-line
        } else {
          localStorage.removeItem('jwtToken');
          localStorage.removeItem('username');
          sessionStorage.removeItem('jwtToken');
          sessionStorage.removeItem('username');
          commit({ type: 'setjwtFromStorage', jwt: null });
          commit('setUserAuthorized', false);
        }
      }).catch((error) => {
        dispatch('logoutUserFromAuthorizedPages');
        console.log(`Invoking getUserLoginDetails failed with the following error: ${error}`);
      });
    }
  },
  storeLoginInfo({ commit }, payload) {
    if (payload.rememberMeParameter) {
      localStorage.setItem('jwtToken', payload.token);
      localStorage.setItem('username', payload.username);
      commit('setjwtFromStorage', localStorage.getItem('jwtToken'));
    } else {
      sessionStorage.setItem('username', payload.username);
      sessionStorage.setItem('jwtToken', payload.token);
      commit('setjwtFromStorage', sessionStorage.getItem('jwtToken'));
    }
    commit('setUserAuthorized', true);
  },
  callForAuthorizationFB({ commit }, payload) {
    // eslint-disable-next-line
    console.log('Authorization Process with FB TOKEN');
    return axios({
      url: '/authFb',
      method: 'POST',
      data: {
        accessToken: payload.accessToken,
        msisdn: payload.msisdn,
      },
    }).then((response) => {
      // get body data
      const TokenObject = response.data;
      const tokenExists = true;
      if (tokenExists) {
        return axios({
          url: '/user',
          method: 'GET',
          headers: {
            Authorization: TokenObject.token,
          },
        }).then((responseUser) => {
          // get body data
          console.log(`Invoking user via FB with the following username: ${responseUser.data.username}`);
          localStorage.setItem('jwtToken', TokenObject.token);
          localStorage.setItem('username', responseUser.data.username);
          commit('setjwtFromStorage', localStorage.getItem('jwtToken'));
          commit('setUserAuthorized', true);
        }, (responseUser) => {
          // error callback
          console.log(responseUser);
          commit('setUserAuthorized', false);
          return null;
        });
      }
      return null;
    }, (response) => {
      // error callback
      console.log(response);
      console.log('error callback');
      commit('setUserAuthorized', false);
      return null;
    });
  },
  callForAuthorization({ commit }, {
    username, password, rememberMe, cid, fbReferral, clickId, refUrl, campaignId, publisherId, freePlayPoints,
  }) {
    console.log('AUTHORIZATION Process');
    return axios.post('/auth', {
      username,
      password,
      rememberMe,
      freePlayPoints,
      correlationId: cid,
      fbReferral,
      clickId,
      refUrl,
      campaignId,
      publisherId,
    }).then((response) => {
      // get body data
      // console.log(`Invoking /callForAuthorization failed with the following error: ${response}`);
      const TokenObject = response.data;
      return axios({
        url: '/user',
        method: 'GET',
        headers: {
          Authorization: TokenObject.token,
        },
      }).then((responseUser) => {
        // get body data
        console.log(`Invoking user with the following username: ${responseUser.data.username}`);
        if (rememberMe) {
          localStorage.setItem('jwtToken', TokenObject.token);
          localStorage.setItem('username', responseUser.data.username);
          commit('setjwtFromStorage', localStorage.getItem('jwtToken'));
        } else {
          sessionStorage.setItem('username', responseUser.data.username);
          sessionStorage.setItem('jwtToken', TokenObject.token);
          commit('setjwtFromStorage', sessionStorage.getItem('jwtToken'));
        }
        commit('setUserAuthorized', true);
      }).catch((error) => {
        commit('setUserAuthorized', false);
        console.log(`Invoking callForAuthorization failed with the following error: ${error}`);
      });
    }).catch((error) => {
      commit('setUserAuthorized', false);
      console.log(`Invoking callForAuthorization failed with the following error: ${error}`);
    });
  },
  saveLoginEmail({ commit }, email) {
    if (!email || !auth.getJwt()) return Promise.resolve();
    return axios.post('api/saveLoginEmail', { email }, {
      headers: { Authorization: auth.getJwt() },
    }).catch((error) => {
      console.log(`Invoking api/saveLoginEmail failed: ${error}`);
    });
  },
  getBonusPhases({ commit }) {
    return axios({
      url: `api/getBonusPhases`,
      method: 'POST',
      headers: {
        Authorization: auth.getJwt(),
      },
    }).then((response) => {
      if (response.data.responseEnum === 'OPERATION_SUCCESS') {
        const bundles = (!response.data.data.length) ? {} : response.data.data.filter(bonus => bonus.type === 'BUNDLES' && !bonus.dailyBonusType);
        const points = (!response.data.data.length) ? {} : response.data.data.filter(bonus => bonus.type === 'POINTS' && !bonus.dailyBonusType);
        const bonus = (!response.data.data.length) ? {} : response.data.data.filter(bonus => bonus.type !== 'BUNDLES' && bonus.type !== 'POINTS' && bonus.dailyBonusType);
        const lantern = response.data.data.find(bonus => bonus.type === 'LIGHT_THE_LANTERNS' && !bonus.dailyBonusType);
        const puzzle = response.data.data.find(bonus => bonus.type === 'PUZZLE' && !bonus.dailyBonusType);

        commit('saveBonusDailyModal', ...bonus);

        if (lantern) {
          commit('saveLanternGame', lantern);
        } else if (puzzle) {
          commit('savePuzzleGame', puzzle);
        }
        let bonusList = [...bundles, ...points];
        if (common.state.showCrossPromotionPhase) {
          bonusList = [...bonusList, {
            active: true,
            type: 'CROSS_PROMOTION',
          }];
        }
        commit('savePhaseBonusList', bonusList); // specific order
      }
    }).catch((error) => {
      console.log(`Invoking getBonuses failed with the following error: ${error}`);
      commit('savePhaseBonusList', []); // specific order
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/actions.js